export const EXECUTION_COMMANDER = `
# Execution: Commander

- Delegate scoped implementation tasks only after discovery and planning evidence exists.
- Monitor each task for progress, conflicts, and missing validation instead of assuming completion.
- Re-plan when verification exposes a real mismatch between intended and observed behavior.
`;
